export default class ProblemVisibility {
    static fromData(data) {
        if (!data) {
            return;
        }

        const problemVisibility = new ProblemVisibility();
        problemVisibility.problem = data.problem;
        problemVisibility.category = data.category;
        problemVisibility.visible = data.visible;

        Object.seal(problemVisibility);
        return problemVisibility;
    }
}
